import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DsnOperationMail } from 'app/models/dsn-operation-mail.model';
import { DsnOperationMailService } from 'app/services/dsn-operation-mail/dsn-operation-mail.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-dsn-operation-mail',
  templateUrl: './dsn-operation-mail.component.html',
  styleUrls: ['./dsn-operation-mail.component.css']
})
export class DsnOperationMailComponent implements OnInit {

  public dsnOperationMails: DsnOperationMail[];
  modalTitle = '';
  labels = {};
  showDetail = false;

  constructor (
    public srvDsnOperationMail: DsnOperationMailService,
    public translate: TranslateService,
    private confirmationService: ConfirmationService
  ) { }

  reloadList() {
    this.dsnOperationMails = [];
    this.srvDsnOperationMail.getAll().subscribe( res => {
      res.forEach(dsn => dsn.paramCode = this.translate.instant(`dsnOperationMailList.${dsn.paramCode}`))
      this.dsnOperationMails = res;
    });
  }

  ngOnInit() {
    this.reloadList();

    this.translate.get([
      'dsnOperationMailList.addTitle',
      'dsnOperationMailList.editTitle'
    ]).subscribe((res) => {
      this.labels['addTitle'] = res['dsnOperationMailList.addTitle'];
      this.labels['editTitle'] = res['dsnOperationMailList.editTitle'];
    });

  }

  showAddOrEditDialog(data): void {
    console.log(data)
    this.modalTitle = data == null ? this.labels['addTitle'] : this.labels['editTitle'];
    this.srvDsnOperationMail.dsnOperationMailEditing = data == null ? new DsnOperationMail() : data;
    this.showDetail = true;
  }

  delete(record): void {
    this.srvDsnOperationMail.delete(record).subscribe(() => {
      this.reloadList()
    });
  }

  recoverDsnOperationMail(record){
    this.srvDsnOperationMail.recover(record).subscribe(() => {
      this.reloadList()
    });
  }

  dsnOperationMailAdded($event): void {
    this.srvDsnOperationMail.post($event).subscribe(() => {
      this.showDetail = false;
      this.srvDsnOperationMail.dsnOperationMailEditing = null;
      this.reloadList()
    });
  }

  dsnOperationMailUpdated($event): void {
    this.srvDsnOperationMail.put($event, this.srvDsnOperationMail.dsnOperationMailEditing.id).subscribe(() => {
        this.showDetail = false;
        this.srvDsnOperationMail.dsnOperationMailEditing = null;
        this.reloadList()
      }
    )
  }

  closeDialog() {
    this.srvDsnOperationMail.dsnOperationMailEditing = null;
    this.reloadList()
  }

  duplicateDsnOperationMail(data) {
    this.confirmationService.confirm({
      message: this.translate.instant('dsnOperationMailList.duplicateMessage'),
      acceptLabel: 'Ok',
      accept: () => this.srvDsnOperationMail.duplicateDsnOperationMail(data.id).subscribe(() => this.reloadList()),
      rejectVisible: true
    }); 
  }

}


// WEBPACK FOOTER //
// ./src/app/views/administration/dsn-operation-mail/dsn-operation-mail.component.ts